var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.5055 18.5001C10.812 18.5001 9.32733 18.4894 7.97467 18.4574C4.55451 18.6066 1.65121 16.0273 1.50825 12.7126C1.49725 12.574 1.49725 12.4355 1.50825 12.2969V7.70316C1.42027 4.37776 4.13658 1.61725 7.56774 1.54264C7.7107 1.54264 7.85368 1.54264 7.99665 1.54264C9.44829 1.52133 10.8779 1.5 12.3186 1.5C12.8464 1.5 13.3963 1.50001 13.9352 1.51067C14.628 1.51067 15.3319 1.52132 16.0137 1.53197L17.0254 1.54264C20.4456 1.39343 23.3489 3.97273 23.4918 7.28747C23.5028 7.42603 23.5028 7.5646 23.4918 7.70316V12.2969C23.5798 15.6223 20.8745 18.3828 17.4433 18.4574C17.3004 18.4574 17.1574 18.4574 17.0144 18.4574C15.6617 18.4787 14.1881 18.5001 12.5055 18.5001Z",
  stroke: "white",
  strokeWidth: 1.5
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.4283 11.3488C17.9178 11.3488 17.4966 11.8013 17.4839 12.367C17.4839 12.9326 17.8923 13.3851 18.4027 13.3851C18.4155 13.3851 18.4155 13.3851 18.4283 13.3851H18.5559C19.0664 13.3851 19.4875 12.9326 19.5003 12.367C19.4875 11.8013 19.0664 11.3488 18.5559 11.3488H18.4283ZM16.2842 6.66797C15.7737 6.66797 15.3526 7.1205 15.3398 7.68615C15.3398 8.25181 15.7482 8.70434 16.2587 8.70434C16.2715 8.70434 16.2715 8.70434 16.2842 8.70434H16.4119C16.9223 8.70434 17.3435 8.25181 17.3562 7.68615C17.3435 7.1205 16.9351 6.66797 16.4119 6.66797H16.2842Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.2
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.44439 8.97475C5.9339 8.97475 5.51276 9.42728 5.5 9.99294C5.5 10.5586 5.92114 11.0253 6.44439 11.0111H7.77166V12.4535C7.77166 13.0333 8.19279 13.5 8.71604 13.5C9.23929 13.5 9.66043 13.0333 9.66043 12.4535V11.0111H10.9749C11.4854 11.0111 11.9066 10.5586 11.9193 9.99294C11.9066 9.42728 11.4854 8.97475 10.9749 8.97475H9.66043V7.5465C9.66043 6.9667 9.23929 6.5 8.71604 6.5C8.19279 6.5 7.77166 6.9667 7.77166 7.5465V8.97475H6.44439Z",
  fill: "white"
});

var SvgGame = function SvgGame(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGame, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Game.c06ee762.svg";
export { ForwardRef as ReactComponent };